export default "__VITE_ASSET__DVLW38Hj__"